export const SUPPORTED_LOCALES = ['en', 'hi', 'pa', 'te', 'or', 'ta', 'mr', 'bn', 'ur'] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export interface LocaleOption {
  code: SupportedLocale;
  label: string;
  nativeLabel: string;
  htmlLang: string;
  dir?: 'ltr' | 'rtl';
}

export const LOCALE_OPTIONS: LocaleOption[] = [
  { code: 'en', label: 'English', nativeLabel: 'English', htmlLang: 'en' },
  { code: 'hi', label: 'Hindi', nativeLabel: 'हिन्दी', htmlLang: 'hi' },
  { code: 'pa', label: 'Punjabi', nativeLabel: 'ਪੰਜਾਬੀ', htmlLang: 'pa' },
  { code: 'te', label: 'Telugu', nativeLabel: 'తెలుగు', htmlLang: 'te' },
  { code: 'or', label: 'Odia', nativeLabel: 'ଓଡ଼ିଆ', htmlLang: 'or' },
  { code: 'ta', label: 'Tamil', nativeLabel: 'தமிழ்', htmlLang: 'ta' },
  { code: 'mr', label: 'Marathi', nativeLabel: 'मराठी', htmlLang: 'mr' },
  { code: 'bn', label: 'Bengali', nativeLabel: 'বাংলা', htmlLang: 'bn' },
  { code: 'ur', label: 'Urdu', nativeLabel: 'اردو', htmlLang: 'ur', dir: 'rtl' },
];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

export const getSupportedLocale = (language?: string | null): SupportedLocale => {
  const normalized = language?.split('-')[0] as SupportedLocale | undefined;
  return normalized && SUPPORTED_LOCALES.includes(normalized) ? normalized : DEFAULT_LOCALE;
};

export const getLocaleMetadata = (language?: string | null): LocaleOption => {
  const locale = getSupportedLocale(language);
  return LOCALE_OPTIONS.find((option) => option.code === locale) || LOCALE_OPTIONS[0];
};
